export default __webpack_public_path__ + "static/media/map-view-icon.8c79e058.svg";